import { InsuranceInformationReviewInternalStore } from './insuranceInformationReviewInternalStore';

export class InsuranceInformationReviewExternalStore extends InsuranceInformationReviewInternalStore {}
